// removed by extract-text-webpack-plugin
module.exports = {"message":"login-form__message__3KNcn","login-form-container":"login-form__login-form-container__puxgb","login-form-loading-transparent":"login-form__login-form-loading-transparent__3Vao4","name-fields":"login-form__name-fields__L9iJA","confirmation-text":"login-form__confirmation-text__2hXEO","confirmation-text-transparent":"login-form__confirmation-text-transparent__3Iz37 login-form__confirmation-text__2hXEO","button":"login-form__button__2VMcg","input-wrapper":"login-form__input-wrapper__cC_Zl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/login_form/login-form.scss
// module id = 1207
// module chunks = 1